export default __webpack_public_path__ + "static/media/ST4_SPRING_LIFT_550_J.f25b57b5.png";